import * as CSS from 'csstype';

export const chameleon = 'inherit';

// orange
export const heritage = '#ff7e65';
export const sandyButt = '#f6caa2';

//red
export const risingSun = '#ce283D';
export const littlePiggy = '#f0a9b7';

// purple
export const berlinThing = '#752873';
export const lavendork = '#b36ea7';

// blue
export const pacific = '#1f3ca6';
export const carnaval = '#81a3e6';

//green
export const forrestLyf = '#2f9780';
export const mildredsCar = '#a4d2d4';

// brown
export const looseAlmond = '#95837b';
export const theTanTan = '#cbbba5';

// neutrals
export const puntRoad = '#555555';
export const fiftyFirstShade = '#999999';
export const pebbleBeach = '#cccccc';
export const t1000 = '#e6e6e6';
export const karlTheFog = '#f3f2f0';
export const bleachedAs = '#ffffff';

export const semantic = {
    success: forrestLyf,
    error: risingSun,
    info: puntRoad,
    caution: berlinThing,
    callout: heritage,
    active: heritage,
};

export const typography = {
    root: puntRoad,
    heading: puntRoad,
    linkText: pacific,
    small: pebbleBeach,

    blockquote: {
        base: 'inherit',
        cite: pebbleBeach,
    },

    attribution: fiftyFirstShade,
    displayName: puntRoad,
    hr: puntRoad,
    soft: fiftyFirstShade,
    softer: pebbleBeach,
    softText: pebbleBeach,
    softIcon: t1000,
    softIconFocus: pebbleBeach,
    actionHover: pacific,
    contentBorder: t1000,
    contentBackground: bleachedAs,
};

export const vivid = {
    heritage,
    sandyButt,
    risingSun,
    littlePiggy,
    berlinThing,
    lavendork,
    pacific,
    carnaval,
    forrestLyf,
    mildredsCar,
    looseAlmond,
    theTanTan,
};

export const social = {
    twitter: '#55acee',
    facebook: '#3b5998',
    pinterest: '#bd081c',
    linkedin: '#0077b5',
};

export const packages = {
    bronze: '#e0b48c',
    silver: '#b2b2b2',
    gold: '#e8b954',
    platinum: puntRoad,
    custom: carnaval,
};

export const withAlpha = (color: string, alpha: number): string => {
    if (alpha < 0 || alpha > 100) {
        return color;
    }
    const alphaHex = '0'.concat(alpha.toString(16)).slice(-2);

    return `${color}${alphaHex}`;
};

export const getColor = (color: CSS.ColorProperty | Color) => {
    const exists = color in colors;
    if (exists) return colors[color as Color];
    return color;
};

export type Color =
    | 'chameleon'
    | 'heritage'
    | 'sandyButt'
    | 'risingSun'
    | 'littlePiggy'
    | 'berlinThing'
    | 'lavendork'
    | 'pacific'
    | 'carnaval'
    | 'forrestLyf'
    | 'mildredsCar'
    | 'looseAlmond'
    | 'theTanTan'
    | 'puntRoad'
    | 'fiftyFirstShade'
    | 'pebbleBeach'
    | 't1000'
    | 'karlTheFog'
    | 'bleachedAs';

const colors = {
    // Named
    chameleon,
    heritage,
    sandyButt,
    risingSun,
    littlePiggy,
    berlinThing,
    lavendork,
    pacific,
    carnaval,
    forrestLyf,
    mildredsCar,
    looseAlmond,
    theTanTan,
    puntRoad,
    fiftyFirstShade,
    pebbleBeach,
    t1000,
    karlTheFog,
    bleachedAs,

    // Groups
    semantic,
    typography,
    vivid,
    social,
    packages,

    withAlpha,
};

export default colors;
